var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"pa-3"},[_vm._v("STORE REGISTRATION")]),_c('store-status-table',{attrs:{"itemList":_vm.storeStatusList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }